import React, { PureComponent } from 'react';
import { IUser } from 'types';
import storeConnect from 'data/store-connect';
import userStore from 'data/user';

// Components

interface UserPhotoProps {
  uid: string;
  user?: IUser;
  className: string;
}
const storeMap = {
  user: ({ uid, user }) => user || userStore.getUser(uid) || {}
};
@storeConnect(storeMap, [userStore])
class UserPhoto extends PureComponent<UserPhotoProps> {
  render() {
    const { user, className, ...rest } = this.props;
    return <div className={className}>{user.displayName || user.email}</div>;
  }
}

export default UserPhoto;
